import "src/pages/DataStudio/ArenaLock/components/styles_vanilla.css.ts.vanilla.css!=!../../../../../node_modules/@vanilla-extract/webpack-plugin/virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{\"fileName\":\"src/pages/DataStudio/ArenaLock/components/styles_vanilla.css.ts.vanilla.css\",\"source\":\"#H4sIAAAAAAAAA81Y23KjOBB9z1eoamqqdh9ISRiwjb9G6IKVYImAHDuZ2n_fEiAQV-OJJzV5SUi3Wq2jvpzWs0g370UGwa8nAE746l0E1ccYRBDm18MTAM03gvDnoVIpUiFjAAE-a3V4-u_pubaAGgtG7CVKa3WKgR8YI62OP6XTV9msMBM4OrUQQONbjikVMrX6ACSqoKyIgZ9fAcXlkVHwg4UsYLCTegWm4lzGYNesweQ1LdRZUo-oTBUx-MG3POKh40A45SSKek5Gro5WebNBK99WcrsFhBEKmNmfK6m9CxPpUccghNBZshuZHACz7wFjHBoAU_u4eMhZXBosUX4FpcqEgRLzgAfO_ngKl_6xk-91kXNKqesi6cG-3UHoR46Yfq97ELJk77rHbiPIB4ETRIF7gnRSfMPmcTIYW7H4Aio2SO5AJYlYwNwzvdxG5XVWpTtXEiGywTeSLJvOWxedcBftnBWnHjq7GpxWKispFWWe4Y8Y8IxV1nAmUukJzU5lDAiTmhXm3y_nUgv-4RElNZM6BmWOCfMSpi-MyRHmg0rX1SInA3yOGJ8L2eqnCg8hvWMDSNSvKqo6QQVZKT5ZDFCDSA_FCEIXJR8ijkivY1RLMnaNATJ_anbVXgVDB0C7Z34XainurqnFx1zEOC5jIJVkbuDZb3IuSuN6roS1aw8TwoAH5DBAIZhAIaxR0AWWpdBCmbMZIwA--yVguHTTKo-P6p0V_dxD2_1u7yi9fS1-OlHTyDd-7ba9bPv9MIgGad6g5CIyDMRJcN4ccNb05FpzRAGMDZ6pi_cRN4ylpjn2-ARn5B8E4fsReMA3pOdfx2g5VVVqxFodPc9YWn8GJGFNvrb2zysY0ft0kFR5YbdctnCpk7xLz3FtXyzfvkMLOoa1VHEmgskNEpxlk3FxceOidmmYO4t9qDV0_bqJj2nYzW-PioKRtgKcT_LOC_nsx_Nfdgufj7oFBB9gA81g9VA2cuvCkL_aC04YoVPFcoHIMkL2wQov1gxQKJgO3FH3qCKZSTqKXVvXnCmkPUz1v6WKhpr5SUg7baIQ9h2MRhpwoLG9N_fu75jtVdoe6UDQObL7OlVZTu5F3ov2cx2SUR5wdGPwWBgkEJ7tvc1QNTNxJZskPCwNWSiZ9XmQnjOJOEvFEZlj78sg0v4dpoWoQ74Q1NPslGdYM68OpdIwP2i4JV9xofdPiTcyl3VkfIZ5WybWrelPjJaZd_L0t9rYAMLjb6fBzNA2bEzdVvU4agtD1Oez9hsTs9uoo3RWXv503k69mPzRpoxeHtaVXx9gYzxJ9_GaQ2b1s1yDV7fjaZEzDfuS3bJbLxceEdpASTJFXt1V6puftEbtNL_9PILeBi88w8JZrHjSRPU4NDm4_w9zZwGASBYAAA\"}!../../../../../node_modules/@vanilla-extract/webpack-plugin/extracted.js"
export var accordion = 'ig3vrl1l';
export var accordionContent = 'ig3vrl1m';
export var actionButton = 'ig3vrlw';
export var actionButtonActive = 'ig3vrlx';
export var actionButtonGroup = 'ig3vrlv';
export var actionButtons = 'ig3vrl8';
export var backButton = 'ig3vrlp';
export var buttonGroup = 'ig3vrl14';
export var cancelButton = 'ig3vrl16';
export var centeredCell = 'ig3vrl1s';
export var closeButton = 'ig3vrlq';
export var configOption = 'ig3vrlz';
export var configOptionActive = 'ig3vrl10';
export var configOptionGroup = 'ig3vrly';
export var configTypeDescription = 'ig3vrl1r';
export var configurationSection = 'ig3vrl1o';
export var customHeader = 'ig3vrln';
export var defaultConfigTitle = 'ig3vrl1n';
export var detailLabel = 'ig3vrl1e';
export var detailValue = 'ig3vrl1f';
export var detailsGrid = 'ig3vrl1d';
export var emailInput = 'ig3vrlm';
export var errorSection = 'ig3vrlb';
export var errorText = 'ig3vrlc';
export var fileSelectedInfo = 'ig3vrl6';
export var fileSelectedText = 'ig3vrl7';
export var fileUploadContainer = 'ig3vrl13';
export var headerTitle = 'ig3vrlo';
export var infoBox = 'ig3vrl11';
export var loadingContainer = 'ig3vrl17';
export var modalBody = 'ig3vrlr';
export var modalContent = 'ig3vrl0';
export var modalHeader = 'ig3vrl1';
export var modalTitle = 'ig3vrl2';
export var progressBar = 'ig3vrl1c';
export var progressHeader = 'ig3vrla';
export var progressSection = 'ig3vrl9';
export var radioGroup = 'ig3vrl1g';
export var radioInput = 'ig3vrl1i';
export var radioLabel = 'ig3vrl1h';
export var radioOption = 'ig3vrl1j';
export var radioOptionSelected = 'ig3vrl1k';
export var requiredFieldText = 'ig3vrlk';
export var section = 'ig3vrls';
export var sectionDescription = 'ig3vrlu';
export var sectionHeader = 'ig3vrlt';
export var sectionHeaderFlex = 'ig3vrl1p';
export var sectionTitle = 'ig3vrl1q';
export var statusMessage = 'ig3vrl18';
export var statusMessageError = 'ig3vrl1a';
export var statusMessageInfo = 'ig3vrl1b';
export var statusMessageSuccess = 'ig3vrl19';
export var submitButton = 'ig3vrl15';
export var successDetails = 'ig3vrlg';
export var successHeader = 'ig3vrle';
export var successJobId = 'ig3vrlh';
export var successSection = 'ig3vrld';
export var successText = 'ig3vrlf';
export var uploadInstructions = 'ig3vrl3';
export var uploadSection = 'ig3vrl4';
export var uploadSectionTitle = 'ig3vrl5';
export var userInfoDescription = 'ig3vrlj';
export var userInfoNote = 'ig3vrll';
export var userInfoSection = 'ig3vrli';
export var warningBox = 'ig3vrl12';